module.exports = __webpack_public_path__ + "img/default_img.0c3da530.png";